import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Guides, GuideLink, InlineLoader } from '../../components'
import {
  selectCurrentPhoneId,
  selectCurrentPhone,
  selectPreSaleFlag
} from '../App/selectors'
import messages from './messages'
import LanguageProvider from '../LanguageProvider/LanguageProvider'
import { selectGuides, selectCurrentPhoneGuidesId } from './selectors'
import { fetchGuides, setActiveGuide } from './actions'
import { createEvent } from '../UserEvents/actions'
import { DeviceNotLoadedHOC } from '../../hocs'
import SEO from '../../components/SEO'
import { listStructuredData } from '../../helpers/utils'

const renderGuideLinks = (guides, next, query) => {
  return (
    <ul style={{ padding: '0' }}>
      {guides.map((guide, index) => {
        return (
          <GuideLink
            key={`${index}_${guide.val}`}
            text={guide.text}
            guide={guide}
            next={next}
            query={query}
          />
        )
      })}
    </ul>
  )
}

const GuidesContainer = props => {
  const { language, currentPhone, preSaleFlag, guides, createUserEvent, query } = props

  const nextStep = guide => {
    createUserEvent({
      category: 'guides',
      data: { action: 'GuideSelect', target: guide.val }
    })
  }

  return (
    <Fragment>
      <SEO
        script={listStructuredData(window.location.href, guides)}
        description={`Get more help and support on your ${
          currentPhone && currentPhone.name_pretty
            ? currentPhone.name_pretty
            : `device`
        } with our troubleshooting guides.`}
      />
      <Guides
        relatedType="swimlane"
        currentPhone={currentPhone}
        noSideBar={preSaleFlag}
        noSearchBar={preSaleFlag}
        createUserEvent={createUserEvent}
      >
        {guides.length >= 1 ? (
          <div className="animated fadeIn">
            <fieldset style={{ border: 'none', padding: '0' }}>
              <legend>{messages[language].issue}: </legend>
              {renderGuideLinks(guides, nextStep, query)}
            </fieldset>
          </div>
        ) : (
          <InlineLoader />
        )}
      </Guides>
    </Fragment>
  )
}

const mapStateToProps = state => ({
  currentPhoneId: selectCurrentPhoneId(state),
  currentPhone: selectCurrentPhone(state),
  preSaleFlag: selectPreSaleFlag(state),
  guides: selectGuides(state),
  currentPhoneGuidesId: selectCurrentPhoneGuidesId(state),
  query: state.routing.locationBeforeTransitions.query
})

const mapDispatchToProps = dispatch => ({
  setActiveGuideFunc: activeGuide => dispatch(setActiveGuide(activeGuide)),
  fetchGuidesFunc: currentPhoneId =>
    dispatch(fetchGuides.request(currentPhoneId)),
  createUserEvent: event => dispatch(createEvent(event))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguageProvider(DeviceNotLoadedHOC(GuidesContainer)))



// WEBPACK FOOTER //
// ./src/containers/Guides/Guides.js